import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { EnvironmentLoader } from '../../../environments/utils/environment-loader.util';
import { AuthService } from '../../core/auth/auth.service';

@Injectable()
export class LoginGuard  {

    constructor(
        private router: Router,
        public authService: AuthService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // console.log(state.url);
        for (const item of EnvironmentLoader.environment.blockUrls || []) {
            if (state.url.startsWith(item)) {
                if (this.authService.accessToken) return true;
                else {
                    this.router.navigate(["/login"]).then();
                    return false;
                }
            }
        }
        return true;
    }

}
